;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/offers/:id\",\"regex\":\"^/offers/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/cart\"},{\"path\":\"/reviews\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.7";import * as Sentry from '@sentry/nextjs';

import { polyfillFlagEmojis } from '@nutralab/ui';

import './sentry.client.config';

// Before hydration, so the phone field's flags are drawn with the font from the start (Windows).
polyfillFlagEmojis('/fonts/TwemojiCountryFlags.woff2');

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
